import { MessageCircle, Phone, CalendarCheck } from "lucide-react";
import { waLink, PHONE_TEL, scrollToId } from "../../lib/contact";

export const Floating = () => (
  <>
    <a
      data-testid="floating-whatsapp-button"
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="pulse-ring fixed bottom-24 md:bottom-7 right-5 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1fb857] shadow-xl shadow-[#25D366]/30 flex items-center justify-center transition-transform hover:scale-105"
    >
      <MessageCircle size={24} className="text-white" />
    </a>

    <div data-testid="mobile-sticky-bar" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-navy/95 backdrop-blur-xl border-t border-white/10 grid grid-cols-3">
      <a data-testid="mobile-sticky-call" href={`tel:${PHONE_TEL}`} className="flex flex-col items-center gap-1 py-3 text-slate-300 active:text-cyanx">
        <Phone size={17} />
        <span className="text-[10px] font-bold tracking-widest">CALL</span>
      </a>
      <a data-testid="mobile-sticky-whatsapp" href={waLink()} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-1 py-3 text-[#25D366] border-x border-white/10">
        <MessageCircle size={17} />
        <span className="text-[10px] font-bold tracking-widest">WHATSAPP</span>
      </a>
      <button data-testid="mobile-sticky-counselling-button" onClick={() => scrollToId("contact")} className="flex flex-col items-center gap-1 py-3 text-cyanx">
        <CalendarCheck size={17} />
        <span className="text-[10px] font-bold tracking-widest">BOOK</span>
      </button>
    </div>
  </>
);
